/**
 * This permits one to mock the Window Reference if one needs to
 * intercept window-specific operations in unit tests.
 * For example, the Help button creates a pop up window.
 * https://dzone.com/articles/angular-2-how-do-i-get-a-reference-to-the-window-o
 */
import { Injectable } from '@angular/core';
function _window(): any {
  // return the global native browser window object
  return window;
}
@Injectable()
export class WindowRef {
  get nativeWindow(): any {
    return _window();
  }
}
